import apiService from '@/services/apiService';

const actions = {
  getMemberPaxelianClub({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxelian-club/user-membership/find-with-paging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postAboutUsBanner({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('about-us-banner/insert-or-update', payload)
        .then((response) => {
          // commit('postAboutUsBanner', payload);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },


};

export default actions;